export default {
  namespace: 'AccountingVoucher',
  state: {
    economyClassifyTree: [],
    functionSectionTree: [],
  },
  effects: {},
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
